<template>
  <div class="authEnterWith" v-if="isVkIdAvailable && vkontakteClient">
    <ac-divider class="authEnterWith_divider">{{ $t('partsSpeech.or') }}</ac-divider>

    <ac-button
      class="authEnterWith_button-enter-with"
      variant="outlined"
      color="gray"
      block
      @click="onSelectType(vkontakteClient)"
    >
      <i
        class="authEnterWith_button-enter-with_icon"
        :class="`-${vkontakteClient.name}`"
      />
      {{ $t('enterWith') }} VK ID
    </ac-button>
  </div>
</template>

<script lang="ts" setup>
import AcButton from '@ui-kit/components/AcButton.vue'
import AcDivider from '@ui-kit/components/AcDivider.vue'

import { computed, ref, watch } from 'vue'
import { useRouter } from 'vue-router'
import { useStore } from '@web/store'
import useTypesAuth from '@web/composition/useTypesAuth'

defineOptions({
  name: 'AuthEnterWith'
})

const store = useStore()
const router = useRouter()

const authOptions = computed(() => store.getters['authV3/getAuthOptions'])
const isVkIdAvailable = computed(() => authOptions.value?.vkIdAvailable)

const {
  onSelectType,
  clients
} = useTypesAuth({ router, action: 'login' })

const vkontakteClient = computed(() => clients.value.find(client => client.name === 'vkontakte'))
</script>

<style lang="scss" scoped>
.authEnterWith {
  &_divider {
    color: var(--ac-color-gray);
    margin-top: 18px;
  }

  &_button-enter-with {
    border-radius: 42px;
    margin-top: 20px;

    &_icon {
      display: block;
      background-repeat: no-repeat;
      width: 22px;
      height: 22px;
      margin-right: 10px;

      &.-vkontakte {
        background-image: url(@web/platform.v3/assets/icons/vk.svg);
      }
    }
  }
}
</style>
